export function imagePayload(dataUrl) {
  if (typeof dataUrl !== 'string' || dataUrl === '') return null;
  const separator = dataUrl.indexOf(',');
  return separator >= 0 ? dataUrl.slice(separator + 1) : dataUrl;
}

export function imageDataUrl(payload) {
  if (typeof payload !== 'string' || payload === '') return null;
  return /^(?:data:image\/|https?:\/\/|blob:)/i.test(payload) ? payload : `data:image/png;base64,${payload}`;
}
